import PrimaryButton from "components/buttons/primary-button";
import Radio from "components/radio";
import Typography from "components/typography";
import React from "react";
import { IoLocationOutline } from "react-icons/io5";
import { CiStreamOn } from "react-icons/ci";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { Station, SelectedPackage } from "types/promoType";

interface IProps {
  station: Station;
  onSelectPackage: (station: Station, packageId: string) => void;
  isPackageSelected: (station: Station, packageId: string) => boolean;
  selectedPackages: SelectedPackage[];
  onAddToCart: (station: Station, selectedPackages: SelectedPackage[]) => void;
}

const StationItem = ({
  station,
  onSelectPackage,
  isPackageSelected,
  selectedPackages,
  onAddToCart
}: IProps) => {
  const handlePackageSelect = (packageId: string) => {
    onSelectPackage(station, packageId);
  };

  const handleAddToCart = () => {
    if (hasSelectedPackages) {
      onAddToCart(station, selectedPackages);
    }
  };

  const hasSelectedPackages = selectedPackages.length > 0;

  return (
    <Container>
      <Body>
        <StationDetail>
          <StationDetailName>
            <Typography size="2xl" weight="semibold">
              {station.name}
            </Typography>
          </StationDetailName>
          <StationDetailDetailsContainer>
            <StationDetailDetailsItem>
              <IoLocationOutline color={Colors.grey500} size={14} />
              <Typography color={Colors.grey500}>{station.location}</Typography>
            </StationDetailDetailsItem>
            <StationDetailDetailsItem>
              <CiStreamOn color={Colors.grey500} size={14} />
              <Typography color={Colors.grey500}>
                {station.listeners}
              </Typography>
            </StationDetailDetailsItem>
          </StationDetailDetailsContainer>
        </StationDetail>
        <Typography mb="1.2" size="lg" weight="medium">
          {station.type === "Radio"
            ? " Airplay Packages"
            : station.type === "Tv"
            ? "TV Airplay Packages"
            : "Coverage Options"}
        </Typography>
        <PackagesContainer>
          {station.packages.map((item, i) => {
            const isSelected = isPackageSelected(station, item.id);
            return (
              <PackageContainer key={i}>
                <PackageName key={item.id}>
                  <Radio
                    onClick={() => handlePackageSelect(item.id)}
                    value={isSelected}
                  />
                  <Typography>{item.name}</Typography>
                </PackageName>
                <Typography size="lg" weight="medium" color={Colors.yellow400}>
                  {item.price}$
                </Typography>
              </PackageContainer>
            );
          })}
        </PackagesContainer>

        <PrimaryButton
          text={"Add To Promo Plan"}
          disabled={!hasSelectedPackages}
          variant="white"
          onClick={handleAddToCart}
        />
      </Body>
    </Container>
  );
};

export default StationItem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0.8rem;
  background-color: ${Colors.grey700};
  border-radius: 9px;
`;

const Body = styled.div`
  padding: 3.2rem 2.4rem;
  background-color: rgb(0, 0, 0);
  border-radius: 8px;
`;

const StationDetail = styled.div`
  padding-top: 10rem;
  margin-bottom: 1.6rem;
  width: 100%;
  border-bottom: 1px;
  border-bottom-color: ${Colors.grey500};
`;

const StationDetailName = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1.6rem;
`;

const StationDetailDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const StationDetailDetailsItem = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
`;
const PackagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 2.4rem;
`;
const PackageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const PackageName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
